import { Component } from "react";
import { Modal } from "office-ui-fabric-react/lib/components/Modal";
import { DefaultButton } from "office-ui-fabric-react/lib-commonjs";
import PDFReport from "../PDFReport";
import React from "react";
import { connect } from "react-redux";
import "./index.css";
import { togglePdfModal } from "../../actions/pdf-actions";
import ProjectSelectors from "../../reducers/project-reducer";
import MBPDFReport from "../PDFReport/mb_index";

class ReportModal extends Component{
    closeModal = () => {
        this.props.togglePdfModal(false);
    };


    render() {
        const {
            lang,
            content,
            isMultiBed,
        } = this.props;

        return (
            <Modal
                titleAriaId="titleId"
                subtitleAriaId="subtitleId"
                onDismiss={() => this.closeModal()}
                isBlocking={false}
                isOpen={this.props.showPdfModal}
                containerClassName="ms-modalExample-container"
            >
                <div id="subtitleId" className="ms-modalExample-body">
                    <div className="ms-Grid" dir="rtl">
                        <div className="ms-Grid-col ms-sm6 ms-md4 ms-lg2">
                            <DefaultButton onClick={this.closeModal} text={content[lang].close}/>
                        </div>
                    </div>
                    {( !isMultiBed )
                        ? <PDFReport/>
                        : <MBPDFReport/>}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = state => {
    return {
        lang: state.localization.lang,
        content: state.localization.content,
        showPdfModal: state.pdf.showPdfModal,
        isMultiBed: ProjectSelectors.isMultiBedProject(),
    };
};

const mapDispatchToProps = {
    togglePdfModal,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReportModal);



// WEBPACK FOOTER //
// ./src/components/ReportModal/index.js